import React from 'react';
import { Button } from 'antd';
import { MobileOutlined } from '@ant-design/icons';

const OpenInAppButton = ({ recipeId }) => {
  const handleOpenInApp = () => {
    // Deep link to mobile app using Universal Links (iOS) / App Links (Android)
    // The path matches the app site association configuration
    const deepLink = `https://wgts.info/nomnom/recipe/${recipeId}`;

    // Attempt to open the app
    window.location.href = deepLink;

    // Fallback: If app is not installed, redirect to app store after a short delay
    // This timeout allows the app to open if installed
    setTimeout(() => {
      // Check if the page is still visible (if app opened, page would be hidden)
      if (!document.hidden) {
        // App is not installed, could redirect to app store
        // For now, just log - in production, add App Store/Play Store links
        console.log('App not installed. Redirect to app store would happen here.');

        // Example iOS App Store link (update with actual app ID):
        // window.location.href = 'https://apps.apple.com/app/id{YOUR_APP_ID}';

        // Example Android Play Store link (update with actual package name):
        // window.location.href = 'https://play.google.com/store/apps/details?id=com.wgts.nomnom';
      }
    }, 1500);
  };

  return (
    <Button
      type="primary"
      size="large"
      icon={<MobileOutlined />}
      onClick={handleOpenInApp}
      block
      className="open-in-app-button"
    >
      Open in NomNom App
    </Button>
  );
};

export default OpenInAppButton;
